import { UseFormReturn } from 'react-hook-form'
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

interface PersonFormProps {
  form: UseFormReturn<any>
  fields?: ('nom' | 'cognoms' | 'email' | 'telefon' | 'mobil' | 'data_naixement' | 'genere' | 'nacionalitat')[]
  required?: string[]
}

/**
 * Componente reutilizable para campos de persona
 * Uso: <PersonForm form={form} fields={['nom', 'cognoms', 'email']} required={['nom', 'cognoms']} />
 */
export function PersonForm({ 
  form, 
  fields = ['nom', 'cognoms', 'email', 'telefon'], 
  required = [] 
}: PersonFormProps) {
  const generes = [
    { value: 'home', label: 'Home' },
    { value: 'dona', label: 'Dona' },
    { value: 'altre', label: 'Altre' },
    { value: 'no_especificat', label: 'No especificat' }
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {fields.includes('nom') && (
        <FormField
          control={form.control}
          name="nom"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Nom {required.includes('nom') && <span className="text-destructive">*</span>}
              </FormLabel>
              <FormControl>
                <Input {...field} placeholder="Joan" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      {fields.includes('cognoms') && (
        <FormField
          control={form.control}
          name="cognoms"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Cognoms {required.includes('cognoms') && <span className="text-destructive">*</span>}
              </FormLabel>
              <FormControl>
                <Input {...field} placeholder="Garcia Martínez" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      {fields.includes('email') && (
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Email {required.includes('email') && <span className="text-destructive">*</span>}
              </FormLabel>
              <FormControl>
                <Input {...field} type="email" placeholder="joan@example.com" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      {fields.includes('telefon') && (
        <FormField
          control={form.control}
          name="telefon"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Telèfon {required.includes('telefon') && <span className="text-destructive">*</span>}
              </FormLabel>
              <FormControl>
                <Input {...field} type="tel" placeholder="+34 123 456 789" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      {fields.includes('mobil') && (
        <FormField
          control={form.control}
          name="mobil"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Mòbil {required.includes('mobil') && <span className="text-destructive">*</span>}
              </FormLabel>
              <FormControl>
                <Input {...field} type="tel" placeholder="+34 600 000 000" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      {fields.includes('data_naixement') && (
        <FormField
          control={form.control}
          name="data_naixement"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Data de Naixement {required.includes('data_naixement') && <span className="text-destructive">*</span>}
              </FormLabel>
              <FormControl>
                <Input {...field} type="date" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      {fields.includes('genere') && (
        <FormField
          control={form.control}
          name="genere"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Gènere {required.includes('genere') && <span className="text-destructive">*</span>}
              </FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Selecciona..." />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {generes.map((genere) => (
                    <SelectItem key={genere.value} value={genere.value}>
                      {genere.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      {fields.includes('nacionalitat') && (
        <FormField
          control={form.control}
          name="nacionalitat"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Nacionalitat {required.includes('nacionalitat') && <span className="text-destructive">*</span>}
              </FormLabel>
              <FormControl>
                <Input {...field} placeholder="ES" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </div>
  )
}
